// src/router/back.js

import { menuItems } from '../config/menu'
import { projectRoutes } from './modules/projects.routes'
import { documentTypeRoutes } from './modules/document-types.routes'
import { marketCategoryRoutes } from './modules/market-categories.routes'
import { marketTypeRoutes } from './modules/market-types.routes'

// Routes métier internes
const backChildren = [
    {
        path: '',
        name: 'dashboard',
        component: () => import('@/pages/back/Home.vue')
    },
    {
        path: 'projects',
        component: { render: h => h('router-view') },
        children: projectRoutes
    },
    {
        path: 'market-categories',
        component: { render: h => h('router-view') },
        children: marketCategoryRoutes
    },
    {
        path: 'document-types',
        component: { render: h => h('router-view') },
        children: documentTypeRoutes
    },
    {
        path: 'market-types',
        component: { render: h => h('router-view') },
        children: marketTypeRoutes
    }
]

// 🔐 Rôles depuis le menu
function extractProtectedRoutes(items, map = new Map()) {
    items.forEach(item => {
        if (item.route && item.roles) {
            map.set(item.route, item.roles)
        }
        if (item.children) extractProtectedRoutes(item.children, map)
    })
    return map
}

const protectedRoutes = extractProtectedRoutes(menuItems)

// Injection meta sécurité
backChildren.forEach(route => {
    const roles = protectedRoutes.get(route.name)
    if (roles) {
        route.meta = {
            ...(route.meta || {}),
            requiresAuth: true,
            roles
        }
    }
})

export default [
    {
        path: '/dashboard',
        component: () => import('@/pages/layouts/AdminLayout.vue'),
        meta: { requiresAuth: true, roles: ['ADMIN', 'USER'] },
        children: backChildren
    },
    {
        path:'/', name: 'login',
        component: () => import('@/pages/Login'),
    },


    {
        path: '/validate/password',
        name: 'passwordSet',
        component: () => import('@/pages/back/PasswordSet.vue'),
        meta: { public: true }
    },
    {
        path:'/error-page', name: 'errorPage',
        component: () => import('@/pages/ErrorPage'),
        meta: { requiresAuth: true },
    },

]
